import HeiGrid from "../../../../Common/components/HeiGrid/HeiGrid";
import styles from "../../views/ProjectList.module.scss";
import { getColumns } from "../MyProjectsGrid/getMyProjectsGridColumns";
import { useOpcoProjectsGrid } from "../../hooks/useOpcoProjectsGrid";
import { useRef } from "react";
import { defaultSorting } from "../../api/models/defaultSorting";
import usePageTitle from "../../../../Common/hooks/usePageTitle";
import { SettingsKeys } from "../../../../Common/models/storageSettingsKeys";

const OpcoProjectsGrid = () => {
  usePageTitle("OpCo Projects");

  const { fetchGridData } = useOpcoProjectsGrid();
  const callForceRefresh = useRef(null);
  const columns = getColumns();

  return (
    <div className={styles.view}>
      <HeiGrid
        columns={columns}
        fetchGridData={fetchGridData}
        searchPlaceholder="Search project name, team members, cost center"
        defaultSorting={defaultSorting}
        refFunction={callForceRefresh}
        storageSettingsKey={SettingsKeys.OpcoProjectsGrid}
      />
    </div>
  );
};

export default OpcoProjectsGrid;
